const ADDITIONAL_INFO_MATCHER = new RegExp(
  '<[hp]\\d?><b>Zusatzinformationen<\\/b><\\/[hp]\\d?>(.*?)(?=<[hp]\\d?><b>Noch Fragen?)',
  's'
);
const REPLACEMENT_ADDITIONAL_INFO = '';

export const transformWorkdayHtmlAdditionalInfo = (workdayHtml: string) => {
  const [, matchedHtml = ''] = workdayHtml.match(ADDITIONAL_INFO_MATCHER) || [];

  if (!matchedHtml) {
    return '';
  }

  return REPLACEMENT_ADDITIONAL_INFO + matchedHtml;
};
